import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import useFeedsProfile from "../../Hooks/useFeedsProfile";
import { Box, Button, Image } from "native-base";
import { FeedsLoader, PostScrollLoader } from "../../components/loaders";
import Card from "../../components/posts/Card";
import Offline from "react-offline";
import CreatePostpopup from "../../Screens/Home/CreatePostpopup";
import msg from "../../assets/images/create-message.png";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Loc } from "../../App/Loc";
import { useWindowDimension } from "../../Utility/WindowDimensions";

const AVFeedsProfile: React.FC<any> = (props: any) => {
  const { feeds, fetchMore, hasMore, setFeeds, loading } =
    useFeedsProfile(props);
  const { Entity } = props;
  const dimensions = useWindowDimension();
  const [showModal, setShowModal] = useState(false);
  const currentUser = useSelector((state: any) => state.user.user[0]);
  //const postPopupExpanded = useSelector(
  //  (state : RootStateOrAny) => state.user.postPopupExpanded,
  //);
  const isMemberOfEntity = Entity?.members?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isPlayerOfEntity = Entity?.players?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isstaffOfEntity = Entity?.staff?.some((x) => x?.id === currentUser?.id);
  const isParticipantOfEntity = Entity?.participants?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isCurrentUser = Entity?.id === currentUser?.id;
  const isOwner = isstaffOfEntity || isCurrentUser || isParticipantOfEntity;
  const isOneOfEntity =
    isMemberOfEntity || isPlayerOfEntity || isstaffOfEntity || isCurrentUser;
  let IsVisible =
    Entity?.id == "78b5b063-fd3e-4925-92bd-2a1888c6a46a" ||
    Entity?.id == "b495d4e0-bf52-4690-8dc0-677db954aa7f" ||
    Entity?.id == "b495d4e0-bf52-4690-8dc0-677db954aa71" ||
    Entity?.id == "b495d4e0-bf52-4690-8dc0-677db954aa72"
      ? "P"
      : isOwner
        ? "B"
        : !isOneOfEntity && props?.page !== "Home"
          ? "N"
          : props?.page == "Home"
            ? "B"
            : props?.Postdata?.preferences?.memberPost
              ? props?.Postdata?.preferences?.memberPost
              : Entity?.preferences?.memberPost;
  IsVisible = Entity?.type == "Channel" ? "B" : IsVisible;
  const isMobile = dimensions?.width <= 500 || false;
  const [isShowCreatePost, setIsShowCreatePost] = useState(
    props?.isShowCreatePost ?? true,
  );

  const MemoizedLoader = React.memo(() => (
    <Box flex={1} justifyContent="center" alignItems="center">
      <PostScrollLoader />
    </Box>
  ));

  // Memoized Card Component
  const MemoizedCard = React.memo(Card);

  useEffect(() => {
    if (showModal/* || postPopupExpanded*/) {
      document.body.style.overflow = "hidden"; // disable scroll
    } else {
      document.body.style.overflow = "auto"; // enable scroll back
    }
  }, [showModal/*, postPopupExpanded*/]);

  if (loading) {
    return (
      <div className="feed-container">
        {Array(5)
          .fill(null)
          .map((_, i) => (
            <FeedsLoader key={i} />
          ))}
      </div>
    );
  }

  const handleCreatePost = () => {
    setShowModal(true);
  };

  return (
    <Box>
      {!showModal && IsVisible !== "N" && isShowCreatePost && (
        <Offline>
          {({ isOffline }) =>
            !isOffline && (
              <Button
                bgColor="AVColor.primary"
                borderRadius="full"
                padding={3}
                height="45px"
                width="45px"
                onPress={handleCreatePost}
                zIndex={1}
                position="fixed"
                bottom={isMobile ? "110px" : "10px"}
                marginLeft={
                  props?.isHuddlePostTab
                    ? props?.offW
                      ? props.offW - 60
                      : 570
                    : props?.offW
                      ? props?.offW - 60
                      : 100
                }
              >
                <Image source={msg} alt="Create Post" size="25px" />
              </Button>
            )
          }
        </Offline>
      )}

      {/*<div style={ { backgroundColor: "#F5F4F1" } } className="feed-container">*/}
      <div className="feed-container">
        <InfiniteScroll
          dataLength={feeds.length}
          next={fetchMore}
          hasMore={hasMore}
          loader={<MemoizedLoader />}
          //height={ "500px" }
          //endMessage={ <p style={ { textAlign: 'center' } }><b>No more feeds to show.</b></p> }
        >
          {feeds.map((feed) => (
            <div className="posts-list" key={feed.id}>
              <MemoizedCard
                iscommentAccess={props?.previewdata?.iscommentAccess}
                data={feed}
                setFeedChunks={setFeeds}
                feedChunks={feeds}
                previewdata={props?.Entity}
                userInfo={props?.Entity}
                isHuddlePostTab={props?.isHuddlePostTab ?? false}
              />
            </div>
          ))}
        </InfiniteScroll>

        {feeds.length == 0 /*&& !props?.isHuddlePostTab*/ && (
          <div
            style={{
              marginBottom: "-1px",
              marginTop: "40px",
              textAlign: "center",
              top: "4px",
              minHeight: "50px",
            }}
          >
            {Loc.currentLang.post.noFeeds}
          </div>
        )}
      </div>

      {/* Modal to create a post */}
      {showModal && isShowCreatePost && (
        <CreatePostpopup
          visibilityPermission={IsVisible}
          setShowCreatePost={setShowModal}
          Postdata={Entity?.type == "Channel" ? Entity : props?.Postdata}
          setFeedChunks={setFeeds}
          feedChunks={feeds}
          handleAddComment={undefined}
          handlePostComment={undefined}
          showAddComment={false}
          setShowAddComment={undefined}
          setCommentMedia={undefined}
          isHuddlePostTab={props?.isHuddlePostTab}
        />
      )}
    </Box>
  );
};

export default AVFeedsProfile;
